// Selective branding also applies to its enterprise sub-users.
export const POLICY_HOLDER_ENTERPRISE_IDS = [29];

export const isPolicyHolderEnterprise = (user = window.currentUser || {}) => {
  const primary = +(user.is_sub_user ? user.parent_id : user.id) || 0;
  return POLICY_HOLDER_ENTERPRISE_IDS.includes(primary);
};

// Selective's own support line. Everyone else has the standard one
// (888.263.6973) that the pages carry, marked data-support-phone.
export const POLICY_HOLDER_SUPPORT_PHONE = '+1-888-756-0111';

export const showSupportPhone = (user) => {
  if (!isPolicyHolderEnterprise(user)) return;
  document.querySelectorAll('[data-support-phone]').forEach((link) => {
    link.setAttribute('href', `tel:${POLICY_HOLDER_SUPPORT_PHONE.replace(/[^\d+]/g, '')}`);
    const value = link.querySelector('[data-support-phone-value]');
    if (value) value.textContent = POLICY_HOLDER_SUPPORT_PHONE;
  });
};
